import gql from 'graphql-tag'

export const POSTING_DELETE_MUTATION = gql`
    mutation postingDelete(
        $id: ID!
    ) {
        postingDelete(
            id: $id
        ) {
            status
        }
    }
`
